import { createFileRoute } from "@tanstack/react-router";
import { RouteError } from "../../../shared/components/RouteError";
import { RoutePending } from "../../../shared/components/RoutePending";

/**
 * @purpose Edit one station's geofence and location
 * @primary Station form
 * @persona danilo-tech
 */
export const Route = createFileRoute("/app/admin/stations/$id")({
  errorComponent: ({ error }) => <RouteError error={error} />,
  pendingComponent: RoutePending,
});
